var _toArray = require("/home/runner/work/pixelmatters-10-years/pixelmatters-10-years/node_modules/.pnpm/@babel+runtime@7.23.4/node_modules/@babel/runtime/helpers/toArray.js");
var createInvariantWithPrefix = function createInvariantWithPrefix() {
  var errorPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[prefix]: ';
  return function (condition) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invariant failed';
    if (!condition) {
      throw new Error(errorPrefix + message);
    }
  };
};
var memoize = function memoize(fn) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var key = JSON.stringify(args);
    if (!map.has(key)) {
      map.set(key, fn.apply(void 0, args));
    }
    return map.get(key);
  };
};
var get = function get(obj, path, defaultValue) {
  var _ref = typeof path === 'string' ? path.replace(/\[(\d+)]/g, '.$1').split('.') : path,
    _ref2 = _toArray(_ref),
    head = _ref2[0],
    tail = _ref2.slice(1);
  if (!obj[head]) return defaultValue;
  return !tail.length ? obj[head] : get(obj[head], tail, defaultValue);
};
module.exports = {
  createInvariantWithPrefix: createInvariantWithPrefix,
  memoize: memoize,
  get: get
};